import Panzoom from '@panzoom/panzoom'

let recycleareamap = {
    initContainers: function (places) {
        if (!places) {
            return;
        }
        if (places.length > 0 && typeof (places) === "string") {
            places = JSON.parse(places);
        }

        var svgcontainers = document.getElementById("Containers"); 
        if (svgcontainers != null && !svgcontainers.classList.contains('rendered')) {
            svgcontainers.classList.add('rendered');
            var areamapsblock = document.getElementById("RecycleCentralAreamapsBlock");
            recycleareamap.initButtons(svgcontainers, areamapsblock);
            if (areamapsblock != null) {
                document.getElementById('ContainerListsToggle').onclick = function () {
                    document.getElementById('ContainerLists').classList.toggle('containerlistsactive');

                    var containerlistsactive = document.querySelector('.containerlistsactive') !== null;
                    if (window.innerWidth < 992) {

                        var activesymbols = document.querySelector('.activesymbols') !== null;
                        if (activesymbols || containerlistsactive) {
                            document.querySelectorAll(".tab-container").forEach(e => e.classList.add('hide-tab'));
                        } else {
                            document.querySelectorAll(".tab-container").forEach(e => e.classList.remove('hide-tab'));
                        }
                    }
                    else {
                        if (containerlistsactive) {
                            document.querySelectorAll(".svg-holder").forEach(e => e.classList.add('listvisible'));
                        } else {
                            document.querySelectorAll(".svg-holder").forEach(e => e.classList.remove('listvisible'));
                        }
                    }

                }
            }

            places.forEach(function (container) {

                const value = container.containerValue;
                const currentContainer = document.getElementById(value);

                if (currentContainer != null) {
                    currentContainer.classList.replace("hiddencontainer", "visiblecontainer");
                    currentContainer.onclick = function () {
                        recycleareamap.showDescription(this.classList, value, svgcontainers);
                    }
                    document.getElementById("close-" + value).onclick = function () {
                        svgcontainers.querySelectorAll(".activecontainer").forEach(e => e.classList.remove('activecontainer'));
                        document.querySelectorAll(".activesymbols").forEach(e => e.classList.remove('activesymbols'));
                        document.querySelectorAll(".tab-container").forEach(e => e.classList.remove('hide-tab'));
                    }

                    var skylt = currentContainer.querySelector("#Skylt");
                    var skyltaktiv = currentContainer.querySelector("#SkyltAktiv");
                    var skyltdubbel = currentContainer.querySelector("#SkyltDubbel");
                    var skyltdubbelaktiv = currentContainer.querySelector("#SkyltDubbelAktiv");
                    const sortTypes = container.sortTypes;
                    var dubbel = sortTypes.length > 1;
                    if (dubbel) {
                        if (skyltdubbelaktiv != null) {
                            var rects = skyltdubbelaktiv.getElementsByTagName("rect");
                            recycleareamap.addSymbol(container, currentContainer, rects, dubbel);
                        }
                        if (skylt != null && skylt.parentElement === currentContainer) {
                            currentContainer.removeChild(skylt);
                        }
                        if (skyltaktiv != null && skyltaktiv.parentElement === currentContainer) {
                            currentContainer.removeChild(skyltaktiv);
                        }
                    }
                    else if (skyltaktiv != null) {
                        var rect = skyltaktiv.getElementsByTagName("rect");

                        recycleareamap.addSymbol(container, currentContainer, rect, dubbel);

                        if (skyltdubbel != null && skyltdubbel.parentElement === currentContainer) {
                            currentContainer.removeChild(skyltdubbel);
                        } if (skyltdubbelaktiv != null && skyltdubbelaktiv.parentElement === currentContainer) {
                            currentContainer.removeChild(skyltdubbelaktiv);
                        }
                    }
                    if (skylt != null && skylt.parentElement === currentContainer) {
                        currentContainer.removeChild(skylt);
                    }
                    if (skyltaktiv != null && skyltaktiv.parentElement === currentContainer) {
                        currentContainer.removeChild(skyltaktiv);
                    }
                    if (skyltdubbel != null && skyltdubbel.parentElement === currentContainer) {
                        currentContainer.removeChild(skyltdubbel);
                    } if (skyltdubbelaktiv != null && skyltdubbelaktiv.parentElement === currentContainer) {
                        currentContainer.removeChild(skyltdubbelaktiv);
                    }
                }
            });
        }
    },
    showDescription: function (classList, currentContainer, svgcontainers) {

        const currentSymbols = document.getElementById("val-" + currentContainer);
        if (classList.contains('activecontainer')) {
            classList.remove('activecontainer');
            if (currentSymbols != null) {
                currentSymbols.classList.remove('activesymbols');
            }
            document.querySelectorAll(".tab-container").forEach(e => e.classList.remove('hide-tab'));
        }
        else {
            svgcontainers.querySelectorAll(".activecontainer").forEach(e => e.classList.remove('activecontainer'));
            document.querySelectorAll(".activesymbols").forEach(e => e.classList.remove('activesymbols'));
            currentSymbols.classList.add('activesymbols');
            classList.add('activecontainer');
            document.querySelectorAll(".tab-container").forEach(e => e.classList.add('hide-tab'));
        }

    },
    addSymbol: function (container, currentContainer, rect, dubble) {

        var svgskylt = "";
        var icon = "";
        var typeClass = "singel";

        var x = rect[0].getAttribute("x");
        var y = rect[0].getAttribute("y");
        var height = 56;
        var width = 56;
        if (dubble) {
            var vertical = rect[0].getAttribute("y") != rect[1].getAttribute("y");
            typeClass = vertical ? "vertical" : "horizontal";
            if (vertical) {
                svgskylt = '<svg class="eJtcQFKRapB1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 57 119.1" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g class="eJtcQFKRapB2_ts" transform="translate(28.4,110.5) scale(1,1)"><g transform="translate(-28.399999,-110.5)"><rect width="41.7" height="41" rx="0" ry="0" transform="translate(7.6 69.5)" fill="#fff"/><rect width="41.7" height="41" rx="0" ry="0" transform="translate(7.6 28.5)" fill="#fff"/><line x1="47.4" y1="69.5" x2="9.4" y2="69.5" fill="none" stroke="#fff" stroke-width="0.15" stroke-miterlimit="10"/></g></g><g transform="translate(.000001 0)"><g class="eJtcQFKRapB7_ts" transform="translate(28.399999,110.5) scale(1,1)"><path class="eJtcQFKRapB7" d="M30.5,110.5h18.6c.2,0,.3-.1.3-.3v-81.4c0-.2-.1-.3-.3-.3h-41.2c-.2,0-.3.1-.3.3v81.4c0,.2.1.3.3.3h10.6" transform="translate(-28.399999,-110.5)" fill="none" stroke="#222" stroke-miterlimit="10"/></g><path d="M28.4,119.1v-5.9c0-1.5,1.2-2.7,2.7-2.7h1.9" fill="none" stroke="#222" stroke-miterlimit="10"/></g></svg>';
                y = rect[1].getAttribute("y");
                height = 113;
            }

            else {
                width = 113;
                svgskylt = '<svg class="ecnhfvO6R9W1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 113 64.1" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g class="ecnhfvO6R9W2_ts" transform="translate(56.5,55.5) scale(1,1)"><g transform="translate(-56.5,-55.5)"><rect width="41.7" height="41" rx="0" ry="0" transform="translate(56.5 14.6)" fill="#fff"/><rect width="41.7" height="41" rx="0" ry="0" transform="translate(14.8 14.6)" fill="#fff"/><line x1="56.5" y1="16.6" x2="56.5" y2="53.6" fill="none" stroke="#fff" stroke-width="0.15" stroke-miterlimit="10"/></g></g><g><g class="ecnhfvO6R9W7_ts" transform="translate(56.5,55.5) scale(1,1)"><path class="ecnhfvO6R9W7" d="M59.5,55.5h38.6c.2,0,.3-.1.3-.3v-40.4c0-.2-.1-.3-.3-.3h-83.2c-.2,0-.3.1-.3.3v40.4c0,.2.1.3.3.3h31.6" transform="translate(-56.5,-55.5)" fill="none" stroke="#222" stroke-miterlimit="10"/></g><path d="M56.4,64.1v-5.9c0-1.5,1.2-2.7,2.7-2.7h1.9" fill="none" stroke="#222" stroke-miterlimit="10"/></g></svg>';
            }

            icon = recycleareamap.addIcon(currentContainer, container.sortTypes[0].sortTypeValue, typeClass + " first") +
                recycleareamap.addIcon(currentContainer, container.sortTypes[1].sortTypeValue, typeClass + " last");
        }
        else {
            svgskylt = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 57 64.1" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g class="symbolram" transform="translate(28.53381,55.5) scale(1,1)"></g><g paint-order="stroke fill markers"><g class="eKH2vNWY8QP4_ts" transform="translate(28.4,55.5) scale(0.995239,1.000001)"><path class="eKH2vNWY8QP4" d="M31.837721,55.5L49.1,55.5c.2,0,.3-.1.3-.3v-40.4c0-.2-.1-.3-.3-.3h-41.2c-.2,0-.3.1-.3.3v40.4c0,.2.1.3.3.3h10.6" transform="translate(-28.4,-55.5)" paint-order="stroke fill markers" fill="none" stroke="#222" stroke-miterlimit="10"/></g><path d="M28.4,64.1v-5.9c0-1.5,1.2-2.7,2.7-2.7h1.9" fill="none" stroke="#222" stroke-miterlimit="10"/></g></svg>';
            var iconClass = container.sortTypes[0].sortTypeValue;
            icon = recycleareamap.addIcon(currentContainer, iconClass, typeClass);

        }
        container.sortTypes.forEach(
            function (item, index) {
                currentContainer.classList.add(item.sortTypeValue.toLowerCase())
            }
        );

        var foreignObject = document.createElementNS('http://www.w3.org/2000/svg', "foreignObject");
        foreignObject.innerHTML = '<body xmlns="http://www.w3.org/2000/xmlns/" class="containersymbols"><div class="symbols">' + icon + svgskylt + '</div></body>';
        foreignObject.classList.add(typeClass);
        foreignObject.setAttribute("x", x);
        foreignObject.setAttribute("y", y);
        foreignObject.setAttribute("height", height);
        foreignObject.setAttribute("width", width);

        const polygon = currentContainer.getElementsByTagName("polygon")[0];

        if (polygon && polygon.parentElement === currentContainer) {
            currentContainer.insertBefore(foreignObject, polygon.nextSibling);
        }
        else {
            const rect = currentContainer.getElementsByTagName("rect")[0];

            if (rect && rect.parentElement === currentContainer) {
                currentContainer.insertBefore(foreignObject, rect.nextSibling);
            }

        }

    },
    addIcon: function (currentContainer, iconClass, typeClass) {
        return '<div class="recycle-icon-outer ' + typeClass + '"><div class="recycle-icon" style="background-image:url(/images/recyclingguide/fraktionssymboler/' + iconClass.toLowerCase() + '.svg)"></div></div>';

    },
    fullscreen: function (panzoom, areamapsblock) {

        var body = document.getElementsByTagName("body")[0];

        if (window.innerWidth < 990) {
            if (body.classList.contains('fullscreen')) {
                panzoom.reset();
            }
            else {
                panzoom.zoom(2, { animate: true });
            }
        }
        body.classList.toggle('fullscreen');
        var header = document.getElementsByTagName("header")[0];
        if (areamapsblock == null && window.innerWidth > 1199) {
            header.classList.toggle('site-header--sticky');
        }
    },

    initButtons: function (svgcontainers, areamapsblock) {

        document.querySelectorAll('.fraktionssymbol').forEach(e => e.onclick = function () {
            svgcontainers.querySelectorAll(".activecontainer").forEach(e => e.classList.remove('activecontainer'));

            const value = e.dataset.symbol;
            svgcontainers.querySelectorAll("." + value).forEach(function (e) {
                const currentContainer = e.id;

                var classList = e.classList;
                recycleareamap.showDescription(classList, currentContainer, svgcontainers);

                if (areamapsblock != null) {
                    if (window.innerWidth < 992) {
                        document.getElementById('ContainerLists').classList.remove('containerlistsactive');
                        //document.querySelectorAll(".tab-container").forEach(e => e.classList.remove('hide-tab'));
                    }

                }

            });
        });

        const elem = document.getElementById('SvgMap')
        var maxscale = 3;
        if (window.innerWidth < 990) {
            maxscale = 5;
        }
        const panzoom = Panzoom(elem, {
            maxScale: maxscale,
            minScale: 1
        })
        panzoom.pan(10, 10)
        panzoom.zoom(1, { animate: true })


        const zoominbutton = document.getElementById('zoominbutton');
        const zoomoutbutton = document.getElementById('zoomoutbutton');

        elem.parentElement.addEventListener('touchmove', function (ev) {
            recycleareamap.checkZoom(panzoom, maxscale);

        });

        document.querySelectorAll('.fullscreenbutton').forEach(e => e.onclick = function () {
            recycleareamap.fullscreen(panzoom, areamapsblock);
        });


        zoominbutton.addEventListener('click', function () {
            panzoom.zoomIn();
            recycleareamap.checkZoom(panzoom, maxscale);
        });
        zoomoutbutton.addEventListener('click', function () {
            panzoom.zoomOut();
            recycleareamap.checkZoom(panzoom, maxscale);
        });
    },
    checkZoom: function (panzoom, maxscale) {
        var zoomlevel = panzoom.getScale();
        if (zoomlevel <= 1) {
            zoomoutbutton.classList.add('zoomactive');
        }
        else { zoomoutbutton.classList.remove('zoomactive'); }
        if (zoomlevel >= maxscale) {
            zoominbutton.classList.add('zoomactive');
        }
        else { zoominbutton.classList.remove('zoomactive'); }
    }
};

export { recycleareamap };
